import React from "react";
import { useTranslation } from "react-i18next";
import "./EsgKpiCard.scss";

export default function EsgKpiCard({ title, value, unit, badge, delta, deltaLabel, icon }) {
  const { t } = useTranslation();

  const deltaPositive = typeof delta === "number" && delta > 0;
  const deltaNegative = typeof delta === "number" && delta < 0;

  return (
    <div className="esg-kpi-card">
      <div className="esg-kpi-card-header">
        <span className="esg-kpi-card-label">{t(title)}</span>
        {badge && (
          <span className={`esg-kpi-card-badge esg-kpi-card-badge--${badge.toLowerCase()}`}>
            {t(`esg.${badge.toLowerCase()}`)}
          </span>
        )}
      </div>
      <div className="esg-kpi-card-body">
        <div className="esg-kpi-card-icon">{icon}</div>
        <div className="esg-kpi-card-value-group">
          <span className="esg-kpi-card-value">{value ?? "–"}</span>
          {unit && <span className="esg-kpi-card-unit">{unit}</span>}
        </div>
      </div>
      {typeof delta === "number" && (
        <div
          className={`esg-kpi-card-delta ${deltaPositive ? "positive" : ""} ${
            deltaNegative ? "negative" : ""
          }`}
        >
          <span>
            {deltaPositive ? "+" : ""}
            {delta}%
          </span>
          {deltaLabel && <span className="esg-kpi-card-delta-label">{deltaLabel}</span>}
        </div>
      )}
    </div>
  );
}
